import { i18n } from '@lingui/core';

// The catalog calls Swedish `se`, which is another language's code in Intl.
const intlLocale = (locale: string) => (locale === 'se' ? 'sv' : locale);

/** Tread depth without the unit, one decimal, in the app language's number format: "2,4" in Norwegian. */
export const formatMm = (valueMm: number, maximumFractionDigits = 1) =>
  new Intl.NumberFormat(intlLocale(i18n.locale), { minimumFractionDigits: 1, maximumFractionDigits }).format(valueMm);
